var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toast"},[_c('transition-group',{staticClass:"toastBox",class:_vm.setPosition,attrs:{"name":_vm.setTransition}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }